'use client';

import { ReactNode } from 'react';

// UI
import { CustomDialog } from '@shared/ui';

// Utils
import { combineClasses } from '@shared/utils';

// Constants
import { YEAR_IN_REVIEW } from '@/constants';
interface YearInReviewDialogProps {
  open: boolean;
  title: string;
  year: number;
  children: ReactNode;
  actions?: ReactNode;
  closeBtnClassName?: string;
  onOpenChange: (open: boolean) => void;
}
export const YearInReviewDialog = ({
  open,
  title,
  year,
  children,
  actions,
  onOpenChange
}: YearInReviewDialogProps) => {
  return <CustomDialog open={open} aria-label={`${YEAR_IN_REVIEW.LABEL} ${year} - ${title}`} onOpenChange={onOpenChange} className={combineClasses('!max-w-5xl p-0 overflow-hidden', 'focus:outline-0 focus-visible:outline-0')} closeBtnClassName="bg-white text-foreground" data-sentry-element="CustomDialog" data-sentry-component="YearInReviewDialog" data-sentry-source-file="index.tsx">
      <div className="flex flex-col">
        <div className="relative aspect-video bg-black">{children}</div>

        <div className="p-4 bg-white border-t border-gray-200">
          <div className="flex justify-between">
            <div className="space-y-1">
              <h3 className="text-xl font-semibold text-ocean-600">{title}</h3>
              <p className="text-sm text-gray-600">
                {YEAR_IN_REVIEW.LABEL} {year}
              </p>
            </div>
            {actions}
          </div>
        </div>
      </div>
    </CustomDialog>;
};
YearInReviewDialog.displayName = 'YearInReviewDialog';